<template>
	<div class="talent-tab pl-24 pr-24">
		<div class="flex-row-center-between mt-12">
			<div class="font-h6-regular yx-color-info">
				<span>共</span>
				<span class="yx-color-text-primary ml-6 mr-6">{{ total }}</span>
				<span>个商品</span>
			</div>
			<date ref="date" @submit="submit" :showTimeStamp="false"></date>
		</div>
		<el-table class="mt-24 table-small" :data="list" header-row-class-name="table-header-row" row-class-name="table-row">
			<el-table-column label="商品信息" min-width="250">
				<template v-slot="{ row }">
					<div class="flex-row-align-center">
						<el-image style="width: 40px; height: 40px" :src="row.productImage" alt="" />
						<div class="box ml-10 yx-color-text-primary font-h5-regular">
							<div class="flex-row" style="width: 100%">
								<el-tooltip class="item" :content="row.productName" effect="dark" placement="top">
									<p class="title">{{ row.productName }}</p>
								</el-tooltip>
								<el-tooltip class="item" effect="dark" placement="top">
									<div slot="content" class="content">
										<span>商品ID</span>
										<span class="ml-10">{{ row.productId }}</span>
										<img src="@/assets/public/copy-icon.png" alt="" @click="copy(row.productId)" />
									</div>
									<p class="ID-sign yx-color-primary">ID</p>
								</el-tooltip>
							</div>
							<p class="flex-row-align-center yx-color-text-regular font-h6-regular">
								<span>售价：</span>
								<span>¥{{ row.productPrice }}</span>
							</p>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="play_num" label="商品来源" width="120">
				<template v-slot="{ row }">
					<div class="yx-color-primary">¥{{ row.payOrderGmv | formatEmpty }}</div>
				</template>
			</el-table-column>
			<el-table-column prop="anchorPayCount" label="出单达人数" width="100"></el-table-column>
			<el-table-column prop="payOrderNum" label="销量" width="100"></el-table-column>
			<el-table-column prop="play_num" label="销售额" width="120">
				<template v-slot="{ row }">
					<div class="yx-color-primary">¥{{ row.payOrderGmv | formatEmpty }}</div>
				</template>
			</el-table-column>
			<el-table-column prop="remark" label="到手服务费" show-overflow-tooltip width="120">
				<template v-slot="{ row }">
					<div class="yx-color-primary">¥{{ row.estimateServiceAmount | formatEmpty }}</div>
				</template>
			</el-table-column>
		</el-table>
		<yx-pagination
			:total="total"
			:current-page="pageInfo.pageNum"
			:page-size="pageInfo.pageSize"
			@size-change="sizeChange"
			@current-change="currentChange"
		/>
	</div>
</template>

<script>
import { queryCommerceGoods } from '@/api/secondColonelManage';
import date from '../date/index.vue';
export default {
	name: 'talentTab',
	props: {
		authorityId: {
			type: [String, Number],
			default: '',
		},
		partnerId: {
			type: [String, Number],
			default: '',
		},
		platformId: {
			type: [String, Number],
			default: dataMap.PLATFORM_DY.value,
		},
	},
	components: {
		date,
	},
	data() {
		return {
			list: [],
			total: 0,
			pageInfo: {
				pageNum: 1,
				pageSize: 20,
			},
		};
	},
	methods: {
		async getInfo() {
			const { start_time, end_time } = this.$refs.date.reset(3, 30);
			this.startDate = start_time;
			this.endDate = end_time;
			this.queryCommerceGoods();
		},
		async queryCommerceGoods() {
			const { pageInfo, authorityId, startDate, endDate, partnerId, platformId } = this;
			const {
				code,
				data: { page = {}, list = [] },
			} = await queryCommerceGoods({ ...pageInfo, authorityId, partnerId, startDate, endDate, type: platformId });
			if (code !== 0) return;
			this.list = list;
			this.total = page.item_total || 0;
		},
		sizeChange(size) {
			this.pageInfo.pageSize = size;
			this.queryCommerceGoods();
		},
		currentChange(index) {
			this.pageInfo.pageNum = index;
			this.queryCommerceGoods();
		},
		submit({ start_time, end_time }) {
			this.startDate = start_time;
			this.endDate = end_time;
			this.queryCommerceGoods();
		},
	},
};
</script>

<style lang="less" scoped>
.talent-tab {
	margin-top: 10px;
	.talent-info {
		display: flex;
		.right {
			margin-left: 8px;
			font-size: 14px;
			color: #4e596a;
			flex: 1;
			overflow: hidden;
			.ellipsis {
				color: #1d2129;
			}
			.number {
				display: flex;
				align-items: center;
				.ellipsis {
					margin-left: 8px;
					flex: 1;
					overflow: hidden;
					color: #4e596a;
				}
			}
		}
	}
	/deep/ .el-table td.el-table__cell {
		border-bottom: 1px solid #f0f1f5;
		color: #1d2129;
		font-size: 14px;
	}
}
.box {
	width: calc(100% - 50px);
}
.title {
	flex: 1;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.ID-sign {
	padding: 0px 4px;
	border-radius: 2px;
	background-color: @color-parachrome;
	cursor: default;
}
.content {
	display: flex;
	align-items: center;
	img {
		margin-left: 8px;
		width: 16px;
		height: 16px;
		cursor: pointer;
	}
}
</style>
